import gql from 'graphql-tag';

export const LIST = gql`
  query listMedia($input: ListMediaInput) {
    listMedia(input: $input) {
      id
      originalName
      mimetype
      src
      ratio
      videoStreamUrl
      thumbnail
      storagePath
      createdBy
      updatedTime
      createdTime
    }
  }
`;

export const SEARCH = gql`
  query searchMedia($input: SearchMediaInput!) {
    searchMedia(input: $input) {
      total
      hits {
        id
        originalName
        mimetype
        ratio
        src
        videoStreamUrl
        thumbnail
        storagePath
        createdBy
        updatedTime
        createdTime
      }
    }
  }
`;
